import Image from 'next/image';
import FiveStarRating from '../../atoms/fiveStarRating/FiveStarRating';
import { formatDate } from '../../../utils/functions.js';

export default function TestimonialCarouselCard(props) {
    const { author_name, rating, review, date, author_picture } = props;
    const author_image = author_picture?.data?.attributes?.url;

    Image.defaultProps = {
        unoptimized: true
    };
    return (
        <div className={`oCard TestimonialCard`}>
            <div className={`cardWrapper`}>
                <div className={`oCardBody`}>
                    <div className={`mCardHeader`}>
                        <svg
                            className={`aQuoteIcon`}
                            width="22"
                            height="19"
                            viewBox="0 0 22 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M5.248 8.99773C6.48533 9.12574 7.488 9.6164 8.256 10.4697C9.06667 11.2804 9.472 12.3044 9.472 13.5417C9.472 14.9071 9.024 16.0591 8.128 16.9977C7.27467 17.8937 6.208 18.3417 4.928 18.3417C3.47733 18.3417 2.28267 17.8084 1.344 16.7417C0.448 15.6751 0 14.1177 0 12.0697C0 8.05907 1.408 4.53907 4.224 1.50974C4.736 0.955068 5.33333 0.677734 6.016 0.677734C6.61333 0.677734 7.14667 0.912401 7.616 1.38173C8.128 1.8084 8.384 2.3204 8.384 2.91773C8.384 3.42973 8.17067 3.9204 7.744 4.38973C6.464 5.75507 5.632 7.29107 5.248 8.99773ZM17.536 8.99773C18.7733 9.12574 19.776 9.6164 20.544 10.4697C21.3547 11.2804 21.76 12.3044 21.76 13.5417C21.76 14.9071 21.312 16.0591 20.416 16.9977C19.5627 17.8937 18.496 18.3417 17.216 18.3417C15.7653 18.3417 14.5707 17.8084 13.632 16.7417C12.736 15.6751 12.288 14.1177 12.288 12.0697C12.288 8.05907 13.696 4.53907 16.512 1.50974C17.024 0.955068 17.6213 0.677734 18.304 0.677734C18.9013 0.677734 19.4347 0.912401 19.904 1.38173C20.416 1.8084 20.672 2.3204 20.672 2.91773C20.672 3.42973 20.4587 3.9204 20.032 4.38973C18.752 5.75507 17.92 7.29107 17.536 8.99773Z"
                                fill="white"
                            />
                        </svg>
                        <FiveStarRating rating={rating} />
                    </div>
                    <div className={`mCardTitle alignRTL`}>
                        <figure className={`mImage`}>
                            <Image
                                src={`${author_image}`}
                                alt={``}
                                width={`35`}
                                height={`35`}
                                className={`aImage`}
                                aria-hidden="true"
                                layout="fixed"
                            />
                        </figure>
                        <p className={`fnt20l aTitle`}>{author_name}</p>
                    </div>
                    <div className={`mText fnt16f fontRTL`}>
                        <p>{review}</p>
                    </div>
                    <p className={`aEntryDate fnt12f`}>{formatDate(date)}</p>
                </div>
            </div>
        </div>
    );
}
